"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");






















































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      deviceTypeList: [], searchData: { sn: '', deviceTypeCode: '', errorCode: '', onlyError: '', starTime: (0, _formatter.datesFormatter)(new Date() - 3600 * 1000 * 24 * 30), endTime: '', page: 1, // 当前页码
        rows: 10 // 页码条
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'sn', label: '设备序列号', isShow: true }, { prop: 'deviceTypeName', label: '设备类型', isShow: true }, { prop: 'errorCode', label: '故障代码', isShow: true }, { prop: 'deviceIp', label: '设备IP', isShow: true }, { prop: 'serverHost', label: '监控服务IP', isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: true }] };}, mounted: function mounted() {var self = this;self.init();self.getDeviceTypeList();}, methods: { init: function init() {var self = this;self.getData('/api/deviceError', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.sn = '';this.searchData.deviceTypeCode = '';this.searchData.errorCode = '';this.searchData.onlyError = '';this.searchData.starTime = '';this.searchData.endTime = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;var start = new Date(this.searchData.starTime);var deliverTimeStart = start.getTime();var end = new Date(this.searchData.endTime);var deliverTimeEnd = end.getTime();if (deliverTimeStart > deliverTimeEnd) {this.$message({ message: '请选择结束时间要大于开始时间', type: 'error' });this.searchData.endTime = '';return false;}if (this.searchData.endTime) {var endTime = this.searchData.endTime;if (endTime.split(' ').length < 2) {endTime = endTime + ' 23:59:59';this.searchData.endTime = endTime;}}this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, getDeviceTypeList: function getDeviceTypeList() {var self = this;self.getData('/api/faDeviceType/getDownList', {}, function (res) {self.deviceTypeList = res;});}, excelFun: function excelFun() {var self = this;var day_30 = 3600 * 30 * 24 * 1000; // 校验时间是否填写
      if (self.searchData.starTime === '') {self.$message({ message: '请选择开始时间',
          type: 'error' });

        return false;
      } else if (self.searchData.endTime === '') {
        self.$message({
          message: '请选择结束时间',
          type: 'error' });

        return false;
      } else if (self.searchData.endTime - self.searchData.starTime > day_30) {
        self.$message({
          message: '只能导出小于等于30天的的时间',
          type: 'error' });

        return false;
      }
      if (this.searchData.endTime) {
        var endTime = this.searchData.endTime;
        if (endTime.split(' ').length < 2) {
          endTime = endTime + ' 23:59:59';
          this.searchData.endTime = endTime;
        }
      }
      if (this.searchData.starTime) {
        var starTime = this.searchData.starTime;
        if (starTime.split(' ').length < 2) {
          starTime = starTime + ' 00:00:00';
          this.searchData.starTime = starTime;
        }
      }
      self.getData('/api/deviceError/export/valid', {
        starTime: self.searchData.starTime,
        endTime: self.searchData.endTime },
      function (res) {
        if (res == null) {
          window.location.href = '/api/deviceError/export?starTime=' +
          self.searchData.starTime + '&endTime=' + self.searchData.endTime + '&deviceTypeCode=' +
          self.searchData.deviceTypeCode + '&errorCode=' + self.searchData.errorCode + '&onlyError=' +
          self.searchData.onlyError + '&sn=' + self.searchData.sn;
        }
      });
    } } };exports.default = _default;